<script>
/*

<template>
  <div>
    <label class="label">{{title}}</label>
    <div v-for="(item,index) in valuesTotal" :key="item.value">
      <label
        :for="sid+index"
        class="radio"
        v-bind:class="{'state-disabled':disabled, 'state-error': model.$error, 'radio-inline': inline}"
      >
        <input
          type="radio"
          :id="sid+index"
          :checked="item.value === model.$model"
          :disabled="disabled"
          :value="item.value"
          @change="onInput($event,item.value)"
          @focus="onFocus($event)"
          @blur="onBlur($event)"
          :name="model.$form.testPath ? model.$path : undefined"
        />
        <i></i>
        <span v-html="item.text"></span>
      </label>
    </div>
    <div v-if="otherLabel">
      <label
        class="radio"
        v-bind:class="{'state-disabled':disabled, 'state-error': model.$error, 'radio-inline': inline}"
      >
        <input
          type="radio"
          :checked="otherIsClicked"
          :disabled="disabled"
          @change="onInputOther($event)"
          :name="model.$form.testPath ? model.$path : undefined"
        />
        <i></i>
        <span v-show="!otherIsClicked">{{otherLabel}}</span>
        <input
          class="form-control"
          :class="{'borderless':borderless, 'text-right':model.$schema.type=='number'||model.$schema.type=='money'||model.$schema.type=='integer'}"
          :name="model.$form.testPath ? model.$path : undefined"
          v-show="otherIsClicked"
          :value="model.$value"
          ref="input"
          :placeholder="otherLabel"
          @input="onInputText"
          @focus="onFocus($event)"
          @blur="onBlur($event)"
        />
      </label>
    </div>
    <w-error :model="model"></w-error>
  </div>
</template>

*/

import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';

function renderItem(self, i, item, h, separator, asterisk, strike) {
  const checked = item.value === self.model.$model;
  return h(
    'div',
    {
      key: i,
      ref: 'root',
      class: {
        'd-inline': self.inline
      }
    },
    [
      h(
        'label',
        {
          attrs: {
            for: i
          },
          staticClass: 'radio',

          class: {
            'state-disabled': self.disabled || item.disabled || self.isDisabled,
            'state-error': self.model.$error,
            'radio-inline': self.inline
          }
        },
        [
          h(
            'input',
            {
              domProps: {
                checked
              },
              attrs: {
                type: 'radio',
                id: i,

                disabled: self.disabled || item.disabled || self.isDisabled,
                value: item.value,
                name: self.model.$form.testPath ? self.model.$path : undefined,
                'aria-invalid': self.model.$error ? true : false,
                'aria-describedby': self.isError? self.dataIds.errId : undefined
              },
              on: {
                focus: self.onFocus,
                blur: self.onBlur,
                change: ($event) => self.onInput($event, false, item.value)
              }
            },
            []
          ),
          h('i'),
          item.children
            ? h(
                'span',
                {
                  class: {
                    'text-strike': strike && !checked && self.model.$model
                  }
                },
                item.children
              )
            : h('span', {
                class: {
                  'text-strike': strike && !checked && self.model.$model
                },
                domProps: {innerHTML: item.text}
              }),
          asterisk ? h('span', {}, asterisk) : null,
          separator ? h('span', {}, ' ' + separator) : null
        ]
      )
    ]
  );
}

export default {
  name: 'w-radio-list',
  components: {WError},
  mixins: [modelMixin],
  props: {
    values: {
      type: Array,
      default: () => [] // tablice trzeba zwracać przez funkcję
    },
    otherLabel: {
      type: String,
      default: null,
      required: false
    },
    inline: {
      type: Boolean,
      default: false,
      required: false
    },
    separator: {
      type: String,
      default: null,
      required: false
    },
    asterisk: {
      type: String,
      default: null,
      required: false
    },
    breakError: {
      type: Boolean,
      default: false,
      required: false
    },
    strike: {
      type: Boolean,
      default: false,
      required: false
    }
    // model: Object
  },
  render(h) {
    if (this.model.$disabled) {
      return h('div', {}, []);
    }

    const items = [];
    const v = this.valuesTotal;
    for (let i = 0; i < v.length; i++) {
      const item = v[i];
      items.push(renderItem(this, `${this.dataIds.sid}_${i}`, item, h, this.otherLabel || i !== v.length - 1 ? this.separator : null, this.asterisk, this.strike));
      /*
      items.push(
        h('div', {key: i}, [
          h(
            'label',
            {
              attrs: {
                for: this.sid + i
              },
              staticClass: 'radio',

              class: {
                'state-disabled': this.disabled || item.disabled,
                'state-error': this.model.$error,
                'radio-inline': this.inline
              }
            },
            [
              h(
                'input',
                {
                  domProps: {
                    checked: item.value === this.model.$model
                  },
                  attrs: {
                    type: 'radio',
                    id: this.sid + i,

                    disabled: this.disabled || item.disabled,
                    value: item.value,
                    name: this.model.$form.testPath ? this.model.$path : undefined
                  },
                  on: {
                    focus: this.onFocus,
                    blur: this.onBlur,
                    change: $event => this.onInput($event, item.value)
                  }
                },
                []
              ),
              h('i'),
              item.children ? h('span', {}, item.children) : h('span', {domProps: {innerHTML: item.text}})
            ]
          )
        ])
      );
      */
    }
    if (this.otherLabel) {
      items.push(
        h(
          'div',
          {
            class: {
              'd-inline': this.inline
            }
          },
          [
            h(
              'label',
              {
                staticClass: 'radio',
                class: {
                  'other-label': this.otherIsClicked,
                  'state-disabled': this.isDisabled,
                  'state-error': this.model.$error,
                  'radio-inline': this.inline
                }
              },
              [
                h(
                  'input',
                  {
                    domProps: {
                      checked: this.otherIsClicked
                    },
                    attrs: {
                      type: 'radio',
                      disabled: this.isDisabled,
                      name: this.model.$form.testPath ? this.model.$path : undefined
                    },
                    on: {
                      change: ($event) => this.onInput($event, true),
                      focus: this.onFocus,
                      blur: this.onBlur
                      /*
                    change($event) {
                      this.onInputOther($event);
                    },
                    focus($event) {
                      this.onFocus($event);
                    },
                    blur($event) {
                      this.onBlur($event);
                    }
                    */
                    }
                  },
                  []
                ),
                h('i'),
                this.otherIsClicked
                  ? h(
                      'input',
                      {
                        staticClass: 'form-control',
                        class: {
                          borderless: this.borderless,
                          'text-right': this.model.$schema.type === 'number' || this.model.$schema.type === 'money' || this.model.$schema.type === 'integer'
                        },
                        attrs: {
                          value: this.model.$value,
                          placeholder: this.otherLabel
                        },
                        ref: 'input',
                        on: {
                          input: this.onInputText,
                          focus: this.onFocus,
                          blur: this.onBlur
                        }
                      },
                      []
                    )
                  : h(
                      'span',
                      {
                        class: {
                          'text-strike': this.strike && !this.otherIsClicked && this.model.$model
                        }
                      },
                      this.otherLabel + (this.asterisk ? this.asterisk : '')
                    )
              ]
            )
          ]
        )
      );
    }
    if (this.inline && this.breakError) {
      items.push(h('br', {}));
    }
    items.push(
      h(WError, {
        class: {
          'd-inline': this.inline
        },
        props: {model: this.model, id: this.dataIds.errId}
      })
    );
    return h(
      'div',
      {
        class: {
          'd-inline': this.inline
        }
      },
      items
    );
  },

  data() {
    return {
    };
  },
  computed: {
    valuesTotal() {
      // console.log('slotValues', this.slotValues);
      return this.values.concat(this.slotValues);
    },
    userOther: {
      get() {
        return this.model.$getUserData('userOtherSelect', false);
      },
      set(newValue) {
        this.model.$setUserData('userOtherSelect', newValue);
      }
    },
    otherIsClicked() {
      if (!this.model.$value) {
        return this.userOther;
      }
      return !this.valuesTotal.map((x) => x.value).includes(this.model.$value);
    }
  },
  created() {
    // console.log('created', this);
    // console.log('slots default', this.$slots.default);
    const slotValues = [];
    if (this.$slots.default && this.$slots.default.length) {
      for (let i = 0; i < this.$slots.default.length; i++) {
        const value = undefined;
        let text = '';
        const vnode = this.$slots.default[i];
        if (vnode.data && vnode.data.attrs) {
          const attrs = vnode.data.attrs;
          if (attrs.value !== undefined) {
            value = attrs.value;

            if (attrs.text !== undefined) {
              text = attrs.text;
            } else if (vnode.text !== undefined) {
              text = vnode.text;
            } else if (vnode.children && vnode.children.length) {
              text = vnode.children[0].text;
            }
            slotValues.push({
              text,
              value,
              children: vnode.children,
              disabled: attrs.disabled !== undefined
            });
          }
        }
      }
    }
    this.slotValues = slotValues;
  },
  methods: {
    onInput(evt, isOther, value) {
      if (this.model.$model && this.msgBox && this.msgBox !== {}) {
        const callback = (buttonPressed) => {
          if (buttonPressed === this.msgBox.buttons.find((x) => x.type === 'doit').value) {
            if (isOther) {
              this.onInputOther(evt);
            } else {
              this.onInputSetter(evt, value);
            }
            if (this.msgBox.callback) {
              this.msgBox.callback();
            }
          } else {
            evt.target.checked = false;
            const elem = this.$refs.root.querySelector(`input[value='${this.model.$model}']`);
            if (elem) {
              elem.checked = true;
            }
          }
        };

        const messageBox = {
          title: this.msgBox.title,
          content: this.msgBox.content,
          buttons: this.msgBox.buttons,
          callback
        };
        this.smartMessageBox(evt, messageBox);
      } else {
        if (isOther) {
          this.onInputOther(evt);
        } else {
          this.onInputSetter(evt, value);
        }
      }
    },
    onInputSetter(evt, value) {
      this.userOther = false;
      if (evt.target.checked) {
        // this.model.$value = evt.target.value;
        // this.model.$value = value;
        this.model.$model = value;
        this.$emit('change', evt);
      }
    },
    onInputOther(evt) {
      // console.log('userOther', this.model.$path, this);
      this.userOther = true;
      // console.log('onInputOther', this.model.$path);
      this.model.$value = '';
      this.model.$reset();
      setTimeout(() => {
        this.$refs.input.focus();
      }, 10);
      this.$emit('change', evt);
    },
    onInputText(evt) {
      // console.log('input text', this.model.$path);
      this.userOther = true;

      this.model.$value = evt.target.value;
    },
    onBlur(evt) {
      this.model.$hasFocus = false;
      this.$emit('blur', evt);
    },
    onFocus(evt) {
      this.model.$hasFocus = true;

      this.$emit('focus', evt);
    }
  }
};
</script>

<style></style>
